export default __webpack_public_path__ + "static/media/timer_replay.67a9fc71.svg";